import { LEADER_BOARD_ROUTE } from './constants';
import http from '../../utils/httpService';

/**
 *
 * @param id
 * @returns {*}
 */
const requestLeaderBoard = ( id ) => {
    const route = `${ LEADER_BOARD_ROUTE }/${ id }/leaderboard`;
    return http.request( route, 'GET' );
};

export { requestLeaderBoard };